import { BrowserRouter as Router } from 'react-router-dom'
import { ConstructionRoutes } from './routes/Routes'
import './App.css'

function App() {
  return (
    <Router>
      <ConstructionRoutes />
    </Router>
  )
}

export default App
